import React__default from 'react';
import { SuffixContainer } from './cell-suffix.styles.js';

var CellSuffix = function CellSuffix(props) {
  var children = props.children;
  return /*#__PURE__*/React__default.createElement(SuffixContainer, null, children);
};

export { CellSuffix };
